module.exports = __webpack_public_path__ + "img/0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d.bb400a72.png";